/**
 * @license
 * Copyright (c) 2019 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */

import {LitElement, html, customElement, property} from 'lit-element';

/**
 * An example element.
 *
 * @slot - This element has a slot
 * @csspart button - The button
 */
@customElement('hanzi-pinyin')
export class HanziPinyin extends LitElement {
//   static styles = css`
//     :host {
//       display: block;
//       border: solid 1px gray;
//       padding: 16px;
//       max-width: 800px;
//     }
//   `;


  @property({type: String})
  clipboard = '';



  @property({type: Boolean})
  showclipboard = false;

  @property({type: String})
  message = '';

  @property({type: String})
  pinyin = '';

  @property({type: Boolean})
  showpinyin = false;

  @property({type: String})
  translation = '';

  @property({type: Boolean})
  showtranslation = false;

  /**
   * The number of times the button has been clicked.
   */
  @property({type: Number})
  count = 0;

  render() {
    return html`
        ${!this.showclipboard ? html`
        <span>
          <input @input="${this.inputChange}" .value="${this.clipboard}" placeholder="Paste/Type Hanzi to see the pinyin">
        </span>`:''}
        ${this.showclipboard ? html`
        <!-- <transition name="slide-fade"> -->
          ${this.showclipboard ? html`<div>${this.clipboard}</div>` : ''}
        <!-- </transition>
        <transition name="slide-fade"> -->
          ${this.showpinyin ? html`<div>${this.pinyin}</div>` : ''}
        <!-- </transition>
        <transition name="slide-fade"> -->
          ${this.showtranslation ? html`<div>${this.translation}</div>` : ''}
        <!-- </transition> -->
        ` : ''}
    `;
  }

  connectedCallback() {
    super.connectedCallback();
    this.setupFromHash();

    window.onhashchange = ()=>{
      this.setupFromHash();
    };
  }

  updated(changedProperties: any) {
    changedProperties.forEach((oldValue: any, propName: any) => {
      oldValue = oldValue;
      // console.log(`${propName} changed. oldValue: ${oldValue}`);
      if(propName === 'clipboard'){
        if(this.clipboard.length > 0){
          this.showclipboard = true;
          window.location.hash = this.clipboard;
        }else{
          this.showclipboard = false;
        }
      }
    });
  }

  inputChange(event: Event){
    const target = event.target as HTMLInputElement
    // console.log("🚀 ~ file: hanzi-pinyin.ts ~ line 95 ~ HanziPinyin ~ inputChange ~ event/target",event,  target.value)

    this.clipboard = target.value;
  }



  setupFromHash(){
    // console.log("🚀 ~ file: hanzi-pinyin.ts ~ line 95 ~ HanziPinyin ~ setupFromHash ~ setupFromHash")
    this.clipboard = decodeURIComponent(window.location.hash.substring(1).trim()).replace(/([a-z\u0080-\u00ff]+) - ([a-z\u0080-\u00ff]+)/gi, '');
    this.clipboard = this.clipboard.replace(/[a-zA-Z\s.,\/#!$%\^&\*;:{}=\-_`~()]/gi,'')
    // console.log("🚀 ~ file: hanzi-pinyin.ts ~ line 120 ~ HanziPinyin ~ setupFromHash ~ this.clipboard", this.clipboard)
    this.pinyin = '..';
    // console.log('a is: '+this.clipboard)
    if(this.clipboard === ''){
      this.clipboard = '';
      this.message = 'Append a chinese charachter to the url to see pinyin #太简单'
    }else{
      this.getPinyin();
      this.getTranslation();
    }
  }

  getPinyin(){
    let url = 'https://hanzi-piny.in/api/hanzi/'+this.clipboard;
    console.log('this.clipboard, url', this.clipboard, url);
    // this.pinyin = '...';
    fetch(url,{'method': "GET"}).then((response)=>{
      console.log('response',response.body);
      this.pinyin = '....'
      return response.json();
    }).then((myJson)=>{
      this.pinyin = '.....'
      console.log('myJson',myJson);
      // if(typeof myJson.text === 'Array'){
      //   myJson.text = myJson.text.join(' ')
      // }
      this.pinyin = myJson[0]?.pinyin;
      if(this.pinyin === "liǎo,liào"){
        this.pinyin = "le"
      }
      document.title = 'Hanzi to Pinyin :: ' + this.clipboard + ' :: ' + myJson[0].pinyin
      this.showpinyin = true;
    }).catch((e)=>{
      console.error("Fetch Request Borked!!!", e)
    });
  }

  getTranslation(){
    let url = `https://hanzi-piny.in/api/hanzi/${this.clipboard}` ;
    // console.log('this.clipboard2', this.clipboard)
    fetch(url,{'method': "GET", credentials: 'omit',}).then((response)=>{
      // console.log('response2',response);
      return response.json();
    }).then((myJson)=>{
      // console.log('myJson2', myJson);

      this.translation = '';
      for (var i = 0; i < myJson.length; i++) {

        var newVal =  myJson[i].definition + ' ';

        if(newVal !== undefined){

          this.translation += newVal;
        }
      }
      this.showtranslation = true;
      // console.log('translation',this.translation )
      // this.translation = myJson.text;
    }).catch((err)=>{
      console.error("Fetch Request Borked 3!!!", err)
    });
  }

  createRenderRoot() {
    return this;
  }


}

declare global {
  interface HTMLElementTagNameMap {
    'hanzi-pinyin': HanziPinyin;
  }
}